import { type Client } from '@microsoft/microsoft-graph-client';
import { resolveSiteId } from './sharePointService';

export async function uploadFile(
  client: Client,
  fileName: string,
  content: ArrayBuffer,
  folderPath: string = 'BillPhotos',
): Promise<string> {
  const siteId = await resolveSiteId(client);

  const response = await client
    .api(
      `/sites/${siteId}/drive/root:/${folderPath}/${fileName}:/content`,
    )
    .putStream(content);

  return response.webUrl;
}

export async function uploadExpenseReport(
  client: Client,
  fileName: string,
  content: ArrayBuffer,
): Promise<string> {
  return uploadFile(client, fileName, content, 'ExpenseReports');
}

export function resizeImage(
  file: File,
  maxWidth: number,
  quality: number,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas context not available'));
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to create blob'));
          }
        },
        'image/jpeg',
        quality,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
}
